exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploader {\n  width: 100%;\n  padding: 40px 15px;\n  text-align: center;\n  border-radius: 10px;\n  font-size: 20px;\n  position: relative;\n}\n.file-input {\n  width: 200px;\n  margin: auto;\n  height: 68px;\n  position: relative;\n}\n.label-cover {\n  background: #fff;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  padding: 10px;\n  border-radius: 4px;\n  margin-top: 7px;\n  cursor: pointer;\n}\n.hidden-input-btn {\n  opacity: 0;\n  z-index: -1;\n}\n", ""]);

// exports
